// context/BackgroundContext.js
import React, { createContext, useState, useEffect, useContext } from 'react';
import { useProject } from './useProject.jsx';

const BackgroundContext = createContext();

export const BackgroundProvider = ({ children }) => {
    const { currentHoverProject, projectsFolder, projectsName, preloadedBackgrounds } = useProject();
    const [textColor, setTextColor] = useState("white");
    const [backgrounds, setBackgrounds] = useState([
        { src: `${process.env.PUBLIC_URL}/BACKGROUND.mp4`, id: Date.now() }
    ]);

    const calculateLuminance = (img) => {
        return new Promise((resolve) => {
            const canvas = document.createElement("canvas");
            const context = canvas.getContext("2d");

            canvas.width = img.width / 4;
            canvas.height = img.height / 2;
            context?.drawImage(img, 0, 0, img.width / 4, img.height / 2, 0, 0, img.width / 4, img.height / 2);

            const imageData = context?.getImageData(0, 0, canvas.width, canvas.height);
            if (!imageData) {
                resolve(1);
                return;
            }

            const { data } = imageData;
            let totalLuminance = 0;
            for (let i = 0; i < data.length; i += 4) {
                const r = data[i] / 255;
                const g = data[i + 1] / 255;
                const b = data[i + 2] / 255;
                const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
                totalLuminance += luminance;
            }
            const averageLuminance = totalLuminance / (data.length / 4);
            resolve(averageLuminance);
        });
    };

    useEffect(() => {
        if (currentHoverProject && preloadedBackgrounds[projectsFolder[projectsName.indexOf(currentHoverProject)]]) {
            const newBackgroundSrc = preloadedBackgrounds[projectsFolder[projectsName.indexOf(currentHoverProject)]];
            setBackgrounds([{ src: newBackgroundSrc, id: Date.now() }]);

            if (newBackgroundSrc.endsWith(".mp4")) {

                setTextColor("white");
            } else if (newBackgroundSrc.endsWith(".jpg") || newBackgroundSrc.endsWith(".png")) {
                const img = new Image();
                img.src = newBackgroundSrc;
                img.onload = async () => {
                    const luminance = await calculateLuminance(img);
                    setTextColor(luminance < 0.5 ? "white" : "#0E101F");
                };
            }
        } else {
            setBackgrounds([{ src: `${process.env.PUBLIC_URL}/BACKGROUND.mp4`, id: Date.now() }]);
            setTextColor("white");
        }
    }, [currentHoverProject, preloadedBackgrounds, projectsName]);

    return (
        <BackgroundContext.Provider value={{ backgrounds, textColor, setBackgrounds }}>
            {children}
        </BackgroundContext.Provider>
    );
};

export const useBackground = () => {
    const context = useContext(BackgroundContext);
    if (!context) {
        throw new Error('useBackground must be used within a BackgroundProvider');
    }
    return context;
};
